import { useApiRequest } from "@hooks/use-api-request";
import { HttpMethod } from "@lib/http.helpers";
import { useQuery } from "@tanstack/react-query";

export const notificationsGroupId = import.meta.env
  .SENDGRID_NOTIFICATIONS_GROUP;

export const useUserEmailPreferences = () => {
  const queryFn = useApiRequest({
    url: "users/me/email-preferences",
    method: HttpMethod.Get,
  });

  return useQuery({
    queryKey: ["user-email-preferences"],
    queryFn,
    select: (data) => {
      return data
        ? data.reduce((acc, g) => {
            acc[g.groupId] = g;
            return acc;
          }, {})
        : {};
    },
  });
};
